<template>
  <div class="container-fluid clinic-quotations">
    <div class="row" style="margin-top: 40px">
      <div class="col">
        <h1 class="clinic-quotations__title">{{ quotations_title }}</h1>
      </div>
    </div>

    <!-- quotation Selector -->
    <div class="clinic-quotation-customers__inputs row form-group">
      <div class="col-sm-6">
        <v-select multiple class="wabident-selector" :filterable="false" @search="searchProducts" :options="products"
          placeholder="Busca el tratamiento/producto aquí ..." v-model="selected_products"></v-select>
        <label class="wabident-info">Tratamiento</label>
      </div>
      <div class="col-sm-6">
        <v-select class="wabident-selector" @search="searchCustomers" :options="customers"
          placeholder="Busca el paciente aquí" v-model="selected_customer"></v-select>
        <label class="wabident-info">Paciente</label>
      </div>
    </div>

    <legend style="font-weight: bold; font-size: 0.7rem">FILTROS</legend>

    <div class="clinic-quotation-customers__inputs row form-group">
      <!-- ClinicSelector -->
      <div v-if="show_clinic_selector" class="col-sm-2">
        <select id="clinic_quotations_clinic_id" v-model="clinic_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(name, id) in clinics" :key="id" :value="id">
            {{ name }}
          </option>
        </select>
        <label for="clinic_quotations_clinic_id" class="wabident-info">Clínica</label>
      </div>
      <!-- DoctorSelector -->
      <div class="col-sm-2">
        <select id="clinic_quotations_doctor_id" v-model="doctor_id" class="custom-select">
          <option value="null">Todos</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="clinic_quotations_doctor_id" class="wabident-info">Doctor</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_quotations_show_approved" v-model="show_approved" class="custom-select">
          <option :value="null">Todos</option>
          <option value="approved">Aprobados</option>
          <option value="partial_approved">Parcialmente aprobados</option>
          <option value="not_approved">Sin aprobar</option>
          <option value="expired">Caducados</option>
        </select>
        <label for="clinic_quotations_show_approved" class="wabident-info">¿Aprobado?</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_quotations_show_category" v-model="product_category_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(cat, id) in categories" :value="cat.id" :key="id">
            {{ cat.name }}
          </option>
        </select>
        <label for="clinic_quotations_show_category" class="wabident-info">Unidad</label>
      </div>

      <div class="col-sm-2" v-if="product_category_id">
        <div class="form-check form-check-inline mb-2">
          <input v-model="product_category_children" type="checkbox" class="form-check-input" value="true"
            id="product_category_children" />
          <label class="form-check-label" for="product_category_children">Incluir sub-unidades </label>
        </div>
      </div>
    </div>

    <legend style="font-weight: bold; font-size: 0.7rem">FECHAS</legend>

    <!-- Period Selector -->
    <div class="clinic-quotations__inputs row form-group">
      <div class="col-sm-2">
        <select id="clinic_quotations_order_by" v-model="order_by" class="custom-select">
          <option value="approved_at">F. Aprobación</option>
          <option value="created_at">F. Alta</option>
        </select>
        <label for="clinic_quotations_order_by" class="wabident-info">Ordenar por ...</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_quotations_order_by_dir" v-model="order_by_dir" class="custom-select">
          <option value="desc">Recientes</option>
          <option value="asc">Antiguos</option>
        </select>
        <label for="clinic_quotations_order_by" class="wabident-info">Sentido</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_quotations_period" v-model="period" class="custom-select">
          <option value="day">Hoy</option>
          <option value="day_prior">Ayer</option>
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="clinic_quotations_period" class="wabident-info">Periodo</label>
      </div>
      <!-- Custom Dates Selector -->
      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_from" id="clinic_quotations_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_quotations_date_from">Desde:</label>
        </div>
      </transition>
      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_to" id="clinic_quotations_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_quotations_date_to">Hasta:</label>
        </div>
      </transition>
      <!-- quotationSelector -->
    </div>

    <div v-if="!is_loading" class="row my-4">
      <div class="col-md-2" v-if="total_quotations">
        <h5>TOTAL</h5>
        <b>{{ total_quotations }}</b>
      </div>

      <div class="col-md-2">
        <h5>
          <span v-if="is_core">
            PLANIFICADO
          </span>
          <span v-else>
            PRESUPUESTADO
          </span>
        </h5>
        <b>{{ total_quoted }}</b>
      </div>

      <div class="col-md-2">
        <h5>
          APROBADO
        </h5>
        <b>{{ total_approved }}</b>
      </div>

      <div class="col-md-2">
        <h5>
          REALIZADO
        </h5>
        <b>{{ total_done }}</b>
      </div>

      <div class="col-md-2">
        <h5>
          PAGADO
        </h5>
        <b>{{ total_paid }}</b>
      </div>

      <div class="
              col
              clinic-quotations__summary
              d-flex
              flex-row
              justify-content-end
              align-items-start
            ">
        <div class="mx-3" style="margin-top: 2px">
          <select v-show="false" id="clinic_report_type" v-model="report_type" class="custom-select">
            <option value="xls">Listado Excel</option>
          </select>
          <label v-show="false" for="clinic_report_type" class="wabident-info">Tipo de Informe</label>
        </div>

        <button :disabled="is_loading" @click="generateReportPDF" class="
                btn btn-primary btn-wabident
                float-right
                d-flex
                justify-content-center
                align-items-center
              ">
          <i class="fas fa-download"></i>&nbsp;Descargar
        </button>
      </div>
    </div>

    <div v-if="!is_loading" class="clinic-quotations__list">
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ date_header }}</th>
            <th v-if="show_clinic_selector">CLINICA</th>
            <th>ESTADO</th>
            <th>PACIENTE</th>
            <th v-if="is_core">PLANIFICADO</th>
            <th v-else>PRESUPUESTADO</th>
            <th>APROBADO</th>
            <th>REALIZADO</th>
            <th>PAGADO</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(quotation, index) in search_quotations">
            <clinic-quotation class="clinic-quotations__row" :quotation="quotation" :key="index" :clinics="clinics"
              :showclinic="show_clinic_selector" :categories="product_categories" :doctors="doctors"
              :orderby="effective_order_by" :core="is_core">
            </clinic-quotation>
          </template>
        </tbody>
      </table>

      <!-- PAGINATION -->
      <div v-if="has_results_available" class="row">
        <div class="col text-center customer-search-pagination my-2">
          <button :disabled="is_first_page" @click="goFirst" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button :disabled="is_first_page" @click="goPrev" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
          </button>
          <label class="customer-search-pagination-locator mx-2">
            Página
            {{ current_page }} de {{ total_pages }}
          </label>
          <button :disabled="is_last_page" @click="goNext" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
          </button>
          <button :disabled="is_last_page" @click="goLast" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="clinic-quotations__loading text-center">
      <h2>
        Buscando
        <i class="fas fa-spin fa-circle-notch"></i>
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_paid: null,
      show_approved: null,
      order_by: "created_at",
      order_by_dir: "desc",
      is_loading: false,
      period: "day",
      date_from: new Date().toISODate(),
      date_to: new Date().toISODate(),
      doctor_id: null,
      clinic_id: null,
      product_type: null,
      product_category_id: null,
      product_category_children: null,
      quotations: [],
      summary: [],
      page: 1,
      selected_product: null,
      selected_products: [],
      products: [],
      product_categories: [],
      customers: [],
      selected_customer: null,
      report_type: "xls",
      hierarchy: [],
    };
  },
  computed: {
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    quotations_title() {
      if (this.is_core) {
        return "PLANES DE TRATAMIENTO";
      }

      return "PRESUPUESTOS";
    },
    total_quoted() {
      if (!this.summary.total_quoted) return "";
      return WabiDent.fmtMoney(this.summary.total_quoted, 2);
    },
    total_approved() {
      if (!this.summary.total_approved) return "";
      return WabiDent.fmtMoney(this.summary.total_approved, 2);
    },
    total_done() {
      if (!this.summary.total_done) return "";
      return WabiDent.fmtMoney(this.summary.total_done, 2);
    },
    total_paid() {
      if (!this.summary.total_paid) return "";
      return WabiDent.fmtMoney(this.summary.total_paid, 2);
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.quotations.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.quotations.current_page == this.quotations.last_page;
    },
    search_quotations() {
      if (this.is_loading) return [];
      if (!this.quotations) return [];
      if (!this.quotations.data) return [];
      return this.quotations.data;
    },
    current_page() {
      if (!this.has_results_available) return 0;
      return this.quotations.current_page;
    },
    total_pages() {
      if (!this.has_results_available) return 0;
      return this.quotations.last_page;
    },
    total_quotations() {
      if (!this.has_results_available) return 0;
      return this.quotations.total;
    },
    has_results_available() {
      if (this.is_loading) {
        return false;
      }

      if (!this.quotations) {
        return false;
      }

      if (!this.quotations.data) {
        return false;
      }

      return this.quotations.data.length > 0;
    },
    show_clinic_selector() {
      return Object.keys(this.clinics).length > 1;
    },
    date_header() {
      if (this.order_by == 'approved_at') {
        return 'F. APROBACION';
      }
      return "F. ALTA";
    },
    effective_order_by() {
      return this.order_by;
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow", "is_core"]),
  },
  watch: {
    doctor_id(val) {
      this.reloadquotations();
    },
    product_category_id(val) {
      this.reloadquotations();
    },
    product_category_children(val) {
      this.reloadquotations();
    },
    product_type(val) {
      this.reloadquotations();
    },
    period(val) {
      this.reloadquotations();
    },
    date_from(val) {
      this.reloadquotations();
    },
    date_to(val) {
      this.reloadquotations();
    },
    clinic_id(val) {
      this.reloadquotations();
    },
    show_paid(val) {
      this.reloadquotations();
    },
    show_approved(val) {
      this.reloadquotations();
    },
    order_by(val) {
      this.reloadquotations();
    },
    order_by_dir(val) {
      this.reloadquotations();
    },
    selected_product(val) {
      this.reloadquotations();
    },
    selected_products(val) {
      this.reloadquotations();
    },
    selected_customer(val) {
      this.reloadquotations();
    },
  },
  methods: {
    reloadquotations() {
      this.page = 1;
      this.loadquotations();
    },
    goFirst() {
      this.page = 1;
      this.loadquotations();
    },
    goPrev() {
      this.page -= 1;
      this.loadquotations();
    },
    goNext() {
      this.page += 1;
      this.loadquotations();
    },
    goLast() {
      this.page = this.total_pages;
      this.loadquotations();
    },
    fillSearchedProducts(products) {
      this.searched_products = products;
      this.products = products.map((p) => {
        return {
          label: p.name,
          value: p.id,
        };
      });
    },
    fillSearchedCustomers(customers) {
      this.searched_customers = customers;
      this.customers = customers.map((p) => {
        return {
          label: `${p.full_name} - #${p.history_number}`,
          value: p.id,
        };
      });
    },
    searchProducts(search, loading) {
      loading(true);
      axios
        .get("/product", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          loading(false);
        });
    },

    searchCustomers(search, loading) {
      loading(true);
      axios
        .get("/customer/search", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.fillSearchedCustomers(response.data);
        })
        .catch((error) => {
          console.log("[ERR] searchCustomers:", error);
        })
        .then(() => {
          loading(false);
        });
    },

    userCan(cap) {
      if (!this.clinic) return false;
      if (!this.clinic.capabilities) return false;
      return this.clinic.capabilities[cap] || false;
    },
    generateReportPDF() {
      let params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        doctor_id: this.doctor_id,
        clinic_id: this.clinic_id,
        report_type: this.report_type,
        show_approved: this.show_approved,
        order_by: this.effective_order_by,
        order_by_dir: this.order_by_dir,
        product_id: this.getSelectedProductId(),
        product_ids: this.getSelectedProductsIds(),
        customer_id: this.getSelectedCustomerId(),
        product_type: this.product_type,
        product_category_id: this.product_category_id,
        product_category_children: Boolean(this.product_category_children) ? 1 : 0,
      };

      let query_params = [];
      for (let field in params) {
        let val = params[field];
        if (Array.isArray(val)) {
          val.forEach(function (v) {
            query_params.push(`${field}[]=${v}`);
          });
        } else if (val) {
          query_params.push(`${field}=${params[field]}`);
        }
      }

      let url = "/clinic/quotations?" + query_params.join("&");
      window.open(url, "_blank");
    },
    getSelectedProductId() {
      if (!this.selected_product) return null;
      return this.selected_product.value;
    },
    getSelectedProductsIds() {
      return this.selected_products.map((x) => {
        return x.value;
      });
    },
    getSelectedCustomerId() {
      if (!this.selected_customer) return null;
      return this.selected_customer.value;
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.hierarchy = response.data;
        });
    },
    addCategory(cat, ret, level) {
      let prefix = '-'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    loadquotations() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          doctor_id: this.doctor_id,
          clinic_id: this.clinic_id,
          show_approved: this.show_approved,
          order_by: this.effective_order_by,
          order_by_dir: this.order_by_dir,
          page: this.page,
          product_id: this.getSelectedProductId(),
          customer_id: this.getSelectedCustomerId(),
          product_ids: this.getSelectedProductsIds(),
          product_type: this.product_type,
          product_category_id: this.product_category_id,
          product_category_children: Boolean(this.product_category_children) ? 1 : 0,
        };

        axios
          .get("/clinic/quotations", { params })
          .then((response) => {
            this.quotations = response.data.results;
            this.product_categories = response.data.product_categories;
            this.page = response.data.results.current_page;
            this.summary = response.data.summary;
            this.date_from = response.data.params.date_from;
            this.date_to = response.data.params.date_to;
          })
          .catch((error) => {
            console.log("[ERR] loadquotations ", error);
            this.msgwindow.error("Error cargando tratamientos realizados");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
  mounted() {
    this.clinic_id = this.clinic.id;
    this.loadquotations();
    this.loadCategories();
  },
};
</script>

<style lang="scss">
.clinic-quotations {
  max-width: 1440px;

  &__title {
    font-size: 32px;
  }

  &__list {
    table {
      th {
        font-size: 15px;
        letter-spacing: 0.3px;
        color: var(--theme-grey);
        border: none;
        position: sticky;
        top: 0;
        z-index: 1;
        background: white;
        border-bottom: 1px #e0e0e0 solid;
      }

      &__row {
        cursor: pointer;
        background-color: transparent;
        transition: all 0.2s;
        border-bottom: 1px #e0e0e0 solid;
        border-top: 1px #e0e0e0 solid;

        &:hover {
          background-color: var(--theme-highlight);
        }

        td {
          font-size: 16px;
          line-height: 20px;
          color: var(--theme-text-color);
        }
      }
    }
  }
}
</style>
